// 统一的modal弹窗

import styles from './index.less';
import { iconfont } from '../../utils/utils';
import $ from 'jquery';

const defaultPrams = {
  closeBtn: true, //是否显示关闭按钮
  // link: {    //是否显示额外的链接按钮
  //   linkTitle: '',
  //   linkSrc: '',
  //   linkType: '_self',
  // },
  link: false, //是否显示额外的链接按钮
  modalBgColor: 'rgba(0, 0, 0, .5)', //modal背景色
};

export default class Modal {
  constructor(props) {
    this.wrapper = props.wrapper;
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this.visible = true;
    this._init();
  }

  _init() {
    this._render();
  }

  _render() {
    this.$dom = $(`<div style="background-color:${this.params.modalBgColor}"></div>`);
    this.$dom.addClass(styles['main-modal']);
    const params = this.params;
    if (params.closeBtn) {
      this._addCloseBtn();
    }
    this._addLink();
    $(this.wrapper).append(this.$dom);
  }
  _addCloseBtn() {
    this.$closeBtn = $(
      `<span class="${styles['close-btn']}">${iconfont('iconUC-quxiao', styles.iconfont)}</span>`,
    );
    this.$closeBtn.on('click', () => {
      this.hide();
    });
    this.$dom.append(this.$closeBtn);
  }
  _addLink() {
    const params = this.params;
    if (params.link && params.link.linkSrc) {
      this.$link = $(
        `<a href="${params.link.linkSrc}" target="${params.link.linkType}"  class="${styles.link}">
          ${iconfont('iconUC-lianjie', styles.iconfont)}
          <span>${params.link.linkTitle}</span>
        </a>`,
      );
      this.$dom.append(this.$link);
    }
  }
  show() {
    this.$dom.fadeIn();
  }

  hide() {
    this.$dom.fadeOut(200, () => {
      this.$dom.remove();
    });
    // const animediv = this.dom.querySelector('.animediv');
    // removeClass(animediv, animate['animate__bounceInLight']);
    // addClass(animediv, animate['animate__bounceOut']);
    // hideNode(this.dom);
    // this.visible = false;
  }
}
